import React, { FC } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { NotificationHandler } from '@yakoffice/notification-handler';
import { ModalHandler } from '@yakoffice/custom-modal';
import { Publisher } from './publisher';
import { matchDeeply, NotFound } from '@yakoffice/shared-components';
import { PubRouteItems } from '../routes';
import { WithAuthentication, WithAuthorisation } from '@yakoffice/with-authorisation';
import { WithPublisherAuthorisation } from '../../auth/WithPublisherAuthorisation';
import './app.sass';
import { SearchVisibilityContextProvider } from './search/SearchV2Context';
import { PageTitleContextProvider } from './pageTitleContext/PageTitleContext';
import { SnackbarHandler } from '@yakoffice/snackbar';

const App: FC = () => {
    return <div id="app">
        <BrowserRouter>
            <Routes>
                <Route path={matchDeeply(PubRouteItems.Projects, PubRouteItems.ProjectIdParam)} element={
                    <NotificationHandler>
                        <SnackbarHandler>
                            <ModalHandler>
                                <WithAuthentication>
                                    <WithAuthorisation toolId="publisher">
                                        <WithPublisherAuthorisation>
                                            <SearchVisibilityContextProvider>
                                                <PageTitleContextProvider>
                                                    <Publisher />
                                                </PageTitleContextProvider>
                                            </SearchVisibilityContextProvider>
                                        </WithPublisherAuthorisation>
                                    </WithAuthorisation>
                                </WithAuthentication>
                            </ModalHandler>
                        </SnackbarHandler>
                    </NotificationHandler>
                } />
                <Route path={'*'} element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    </div>;
};

export default App;
